/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFirmwareResponse } from './search-firmware-response';


export interface SearchFirmwareResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchFirmwareResponse> | null;
}

